import { useState } from "react";
import { Modal } from "./Modal";
import { Button } from "./ui/Button";
import { Field } from "./ui/Field";

interface Props {
  title: string;
  resultLink: string;
  onCommit: (result: { resultLink: string; outcome: string }) => void;
  onCancel: () => void;
}

/**
 * A task cannot reach Done without a result: either a link, or an explicit
 * statement that there is no deliverable, with a one-line reason. Both are
 * stored, so the sheet can always answer "what came out of this".
 */
export function DoneGate({ title, resultLink, onCommit, onCancel }: Props) {
  const [link, setLink] = useState(resultLink);
  const [none, setNone] = useState(false);
  const [why, setWhy] = useState("");
  const [error, setError] = useState("");

  const submit = () => {
    if (none) {
      if (!why.trim()) {
        setError("Say in one line what came out of it.");
        return;
      }
      onCommit({ resultLink: "", outcome: why.trim() });
      return;
    }
    if (!link.trim()) {
      setError("Add the result link, or tick the box below.");
      return;
    }
    onCommit({ resultLink: link.trim(), outcome: "" });
  };

  return (
    <Modal
      title="Finish this task"
      subtitle={title}
      onClose={onCancel}
      actions={
        <>
          <Button variant="quiet" onClick={onCancel}>
            Cancel
          </Button>
          <Button variant="primary" onClick={submit}>
            Mark done
          </Button>
        </>
      }
    >
      <Field label="Result link">
        <input
          className="input"
          type="url"
          placeholder="https://"
          value={link}
          disabled={none}
          onChange={(e) => setLink(e.target.value)}
        />
      </Field>
      <label className="choice">
        <input
          type="checkbox"
          checked={none}
          onChange={(e) => {
            setNone(e.target.checked);
            setError("");
          }}
        />
        <span>There is no deliverable for this one</span>
      </label>
      {none && (
        <Field label="What happened instead">
          <input
            className="input"
            placeholder="Call held, notes in the minutes doc"
            value={why}
            onChange={(e) => setWhy(e.target.value)}
          />
        </Field>
      )}
      <div className="err">{error}</div>
    </Modal>
  );
}
